import { render } from "./GoalKRProgressActivity.vue?vue&type=template&id=1d91d22e"
import script from "./GoalKRProgressActivity.vue?vue&type=script&lang=js"
export * from "./GoalKRProgressActivity.vue?vue&type=script&lang=js"
script.render = render

export default script